import { MapsContextMap } from '@platform/maplibre';
import { ProjectTypes } from '@platform/types';
import { Map } from 'maplibre-gl';
import React from 'react';
import useWorkingLayerInteractivity from '../WorkingLayers/useWorkingLayerInteractivity';

interface Props {
  mapObj: ProjectTypes.MapObject;
  mode: 'view' | 'edit' | 'analyze';
  children?: React.ReactNode;
  withFooter?: boolean;
  onMapMount?: (mapRef: Map) => void;
}

const SeProMap: React.FC<Props> = ({ mapObj, onMapMount, mode, children, withFooter }) => {
  const workingLayerInteractivity = useWorkingLayerInteractivity(mapObj, mode);

  return (
    <div className="relative h-full w-full" key={mapObj.id}>
      <MapsContextMap mapObj={mapObj} withFooter={withFooter} onMount={onMapMount} />
      {children}
      {workingLayerInteractivity}
    </div>
  );
};

export default SeProMap;
